import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Card',
  mixins: [n20ActionButtonMixin],
  inheritAttrs: false,
  props: {
    border: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 40
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    hasOffset: function hasOffset() {
      return this.hasButtons || !!this.$slots.buttons || !!this.title || !!this.icon || !!this.note;
    },
    styles: function styles() {
      if (!this.hasOffset) {
        return null;
      }

      return {
        marginTop: "".concat(parseInt(this.offset) * 2 + 2, "px")
      };
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    cardStyles: function cardStyles() {
      if (!this.hasButtons && !this.$slots.buttons) {
        return {
          'max-width': "calc(100% - ".concat(24, "px)")
        };
      } else {
        var width = 50;
        this.buttons.forEach(function (button) {
          if (button.title) {
            width += button.title.length * 7 + 80;
          } else {
            width += 50;
          }
        });

        if (width > 400) {
          return {
            display: 'none'
          };
        }

        return {
          'max-width': "calc(100% - ".concat(width, "px)")
        };
      }
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    borderStyle: function borderStyle() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'border';

      if (this.border) {
        return "".concat(item, ": ").concat(this.border);
      }

      return '';
    }
  }
};